import Block, { BlockContent } from "~/components/Block";
import { getRichText } from "~/external/prismic";

type IframeEmbedProps = {
  script: string;
  title?: any;
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  color?: string;
};

export default function IframeEmbed(props: IframeEmbedProps) {
  const { script, title, spacingTop, spacingBottom, backgroundColor, color } = props;

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <div style={{ textAlign: "center" }}>{getRichText(title)}</div>

        {/* Output the script as HTML */}
        <div dangerouslySetInnerHTML={{ __html: script }} />
      </BlockContent>
    </Block>
  );
}
